import React, { useState } from 'react';
import { Row, Col, Button, Form, Modal } from 'react-bootstrap';
import profilePic from '../../assets/images/profile-pic.jpg';
import profilePicOne from '../../assets/images/profile-pic-prosumer.jpg';
import Select, { SingleValue } from 'react-select';
import { Uploader } from "uploader";
import { UploadDropzone } from "react-uploader";
import { AuthUser, selectUser } from '../../slices/auth.slice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  ProfileState,
  selectProfile,
  updateProfileAsync,
  updateProfilePictureAsync
} from '../../slices/profile.slice';
import { addToast } from '../../slices/responseNotification.slice';
// import { stringify } from 'querystring';

type SelectOptionType = { id: number, label: string, value: string }

export interface ProfileInfoUpdate {
  legalName: string | null;
  callingName: string | null;
  countryId: number | null;
  mobileNumber: string | null;
  responseStatus?: number;
}

export interface ProfilePictureUpdate {
  imageUrl: string;
}

const BasicInfoTab = () => {

  const PHONE_NUMBER_REGEX_SG: RegExp = /^(\+65|65|8|\b8\d{2})\d{8}$/;

  const PHONE_NUMBER_REGEX_SL: RegExp = /^(?:(?:(?:00|\+)94|0)[1-9]\d{1,2})(?:[ -]?)\d{6,10}$/;

  const PHONE_NUMBER_REGEX_USA: RegExp = /^\d{10}$|^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;

  //const [inputDisabled, setInputDisabled] = useState(true);
  //const [saveBtnDisplayClass, setSaveBtnDisplayClass] = useState('d-none');
  //const [editBtnDisplayClass, setEditBtnDisplayClass] = useState('d-inline');
  const [showModal, setShowModal] = useState(false);
  const [showUploadBtn, setShowUploadBtn] = useState(false);
  const [url, setUrl] = useState<string>('');



  let authUser: AuthUser = useAppSelector(selectUser);

  const uploader = Uploader({
    apiKey: "free"
  });

  const selectOptions: SelectOptionType[] = [
    { id: 1, value: 'Singapore', label: 'Singapore' },
    { id: 2, value: 'Sri Lanka', label: 'Sri Lanka' },
    { id: 3, value: 'USA', label: 'USA' }
  ]

  const profilePicImg = authUser.userType === 'Consumer' ? profilePic : profilePicOne;
  //const auth = JSON.parse(localStorage.getItem('auth')!);

  const dispatch = useAppDispatch();

  const currentProfileInfo: ProfileState = useAppSelector(selectProfile);

  const validateMobileNumber = (mobileNumber: string, countryId: number | null): boolean => {
    if (mobileNumber !== '') {
      if (countryId === 1)
        return PHONE_NUMBER_REGEX_SG.test(mobileNumber);
      if (countryId === 2)
        return PHONE_NUMBER_REGEX_SL.test(mobileNumber);
      if (countryId === 3)
        return PHONE_NUMBER_REGEX_USA.test(mobileNumber);
    }
    return true;
  }

  const [formData, setFormData] = useState<ProfileState>(currentProfileInfo);
  const [isValidMobileNumber, setValidMobileNumber] = useState(validateMobileNumber(currentProfileInfo.mobileNumber ? currentProfileInfo.mobileNumber : '', formData.countryId));
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });

    // validate the mobile number
    if (event.target.name === 'mobileNumber' && event.target.value !== '') {
      setValidMobileNumber(validateMobileNumber(event.target.value, formData.countryId));
    } else {
      setValidMobileNumber(true);
    }
  };

  const handleSelectChange = (selectedOption: SingleValue<SelectOptionType>) => {
    setValidMobileNumber(validateMobileNumber(formData.mobileNumber ? formData.mobileNumber : '', selectedOption ? selectedOption.id : null));
    setFormData({
      ...formData,
      countryId: selectedOption ? selectedOption.id : formData.countryId,
    });
  };

  const handleSubmit = async () => {
    // create body object for update profile
    const profileInfoUpdate: ProfileInfoUpdate = {
      legalName: formData.legalName,
      callingName: formData.callingName,
      countryId: formData.countryId,
      mobileNumber: formData.mobileNumber,
    }
    // call profile update API
    const response = await dispatch(updateProfileAsync({ ...profileInfoUpdate, id: authUser.userId }));
    //setInputDisabled(true);
    const status: ProfileInfoUpdate = JSON.parse(JSON.stringify(response.payload));
    if (status.responseStatus === 204) {
      dispatch(addToast({
        id: Date.now(),
        type: 'success',
        message: 'Successfully updated profile informations'
      }))
    } else {
      setFormData(currentProfileInfo);
      dispatch(addToast({
        id: Date.now(),
        type: 'danger',
        message: 'Error occurred while updating profile informations'
      }))
    }
  }

  const handleFileUpload = async () => {
    const response = await dispatch(updateProfilePictureAsync({ id: authUser.userId, imageUrl: url }));
    setShowModal(false);
    const status: ProfileInfoUpdate = JSON.parse(JSON.stringify(response.payload));
    if (status.responseStatus === 204) {
      dispatch(addToast({
        id: Date.now(),
        type: 'success',
        message: 'Successfully updated the profile picture'
      }))
    } else {
      dispatch(addToast({
        id: Date.now(),
        type: 'danger',
        message: 'Error occurred while updating the profile picture'
      }))
    }
  }

  const onCancled = () => {
    setFormData(currentProfileInfo);
    setValidMobileNumber(validateMobileNumber(currentProfileInfo.mobileNumber ? currentProfileInfo.mobileNumber : '', formData.countryId));
  }

  return (
    <div>
      <Row>
        <Col md="4" lg="3">
          <div className='profilePic'>
            <img alt='profilePicImg' src={currentProfileInfo.imageUrl ? currentProfileInfo.imageUrl : profilePicImg} />
            <Button className='photoBtn' onClick={() => setShowModal(!showModal)}><i className="fa-solid fa-camera"></i></Button>

            <Modal size='lg' show={showModal} onHide={() => setShowModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Upload profile picture</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <UploadDropzone uploader={uploader}
                  options={{
                    multi: true,
                    editor: {
                      images: {
                        crop: true,
                        cropRatio: 1 / 1,
                        cropShape: "circ"
                      }
                    },
                  }}
                  onUpdate={files => {
                    if (files.length === 0) {
                      console.log('No files selected.')
                    } else {
                      console.log('Files uploaded:');
                      setUrl(files[0].fileUrl);
                      setShowUploadBtn(!showUploadBtn);
                    }
                  }}
                  width="100%"
                  height="450px"
                />
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => setShowModal(false)} variant="gray">Cancel</Button>
                {(showUploadBtn && url !== '') ? <Button onClick={() => handleFileUpload()} variant="primary">Upload</Button> : <></>}

              </Modal.Footer>
            </Modal>
          </div>
          {/* <div className='billingPeriod mt-4'>
            <h6 className='w700 mb-0'>Billing period</h6>
            <p>BP20</p>
          </div>
          <div className='depositAmount mt-4'>
            <h6 className='w700 mb-0'>Deposit amount</h6>
            <p>฿0</p>
          </div>
          <div className='contractEndDate mt-4'>
            <h6 className='w700 mb-0'>Contract end date</h6>
            <p>31 Mar '21</p>
          </div> */}
        </Col>
        <Col md="12" lg="6">
          <Form>
            <Form.Group className="mb-3" controlId="legalName">
              <Form.Label>Legal Name</Form.Label>
              <Form.Control
                name='legalName'
                //disabled={inputDisabled}
                type="text"
                placeholder="Legal Name"
                value={formData.legalName ? formData.legalName : ''}
                onChange={handleInputChange} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="alias">
              <Form.Label>Alias</Form.Label>
              <Form.Control
                name='callingName'
                //disabled={inputDisabled}
                type="text"
                placeholder="Alias"
                value={formData.callingName ? formData.callingName : ''}
                onChange={handleInputChange} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Email</Form.Label>
              <Row>
                <Col xs="12" sm="8">
                  <Form.Control
                    disabled
                    type="email"
                    placeholder="Email"
                    value={currentProfileInfo.emailAddress ? currentProfileInfo.emailAddress : ''} />
                </Col>
                <Col xs="12" sm="4" className=' align-self-center mt-2 mt-sm-0'>
                  {
                    (currentProfileInfo.isEmailVerified) ? <span className='text-primary w700 me-2'>Verified</span>
                      : <span className='text-danger w700'>Verify</span>
                  }
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3" controlId="country">
              <Form.Label>Country</Form.Label>
              <Row>
                <Col xs="12" sm="8">
                  <Select
                    name='countryId'
                    value={selectOptions.find((option) => option.id === formData.countryId)}
                    className='selectBox'
                    options={selectOptions}
                    classNamePrefix="select"
                    //isDisabled={inputDisabled}
                    onChange={handleSelectChange}
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3" controlId="mobile">
              <Form.Label>Mobile</Form.Label>
              {
                (!isValidMobileNumber && formData.mobileNumber) ?
                  <Row>
                    <Col md="8">
                      <Form.Text>Please enter a valid mobile number</Form.Text>
                    </Col>
                  </Row> : <></>
              }
              <Row>
                <Col xs="12" sm="8">
                  <Form.Control
                    name='mobileNumber'
                    type="text"
                    isValid={isValidMobileNumber && formData.mobileNumber !== ''}
                    isInvalid={!isValidMobileNumber}
                    placeholder="Mobile"
                    value={formData.mobileNumber ? formData.mobileNumber : ''}
                    onChange={handleInputChange}
                  />
                </Col>
                <Col xs="12" sm="4" className=' align-self-center mt-2 mt-sm-0'>
                  {
                    (currentProfileInfo.isMobileVerified) ? <span className='text-primary w700 me-2'>Verified</span>
                      : <span className='text-danger w700'>Verify</span>
                  }
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3">
              {/* {inputDisabled ?
                <Button onClick={() => setInputDisabled(!inputDisabled)}>Edit</Button> : */}
              <div>
                <Button
                  onClick={() => onCancled()}
                  variant='gray' className="me-2 mt-2">Cancel</Button>
                <Button
                  variant='primary'
                  className="mt-2"
                  disabled={!isValidMobileNumber}
                  onClick={() => handleSubmit()}>Save</Button>
              </div>
              {/* } */}
            </Form.Group>
          </Form>
        </Col>
      </Row>
    </div>
  );

}
export default BasicInfoTab;
